/* eslint-disable */

import axios from "axios";

export default class ConsultaMunicipios {
  constructor(tokenBearer, url) {
    this.tokenBearer = tokenBearer;
    this.url = url;
  }

  getMunicipiosConsultados(args = "") {
    var url = `${this.url}/api/unimed/enderecos/consulta/municipios/?${args}`;

    return new Promise(async (resolve, reject) => {
      await axios({ method: "get", url,headers: { Authorization: this.tokenBearer } })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async getExportarMunicipios (args) {
    var url = `${this.url}/api/unimed/enderecos/municipios/exportar?${args}`;

    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: url,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob'
      }
      
      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
